// @flow
import * as React from 'react';
import { ProviderOutput } from '@coverright/data-access/types/medicare';
import { Box, Divider, Fade, Paper, Popper, SxProps, Typography } from '@mui/material';
import { colors } from '@coverright/ui/themes';
import { ProviderAddressOutput } from '@coverright/data-access/types/medicare';

type Props = {
  doctor: ProviderOutput
};

export function DoctorAddressesPopup(props: Props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  if (props.doctor.addresses.length <= 1) {
    return null;
  }

  return (
    <>
      <Typography
        sx={{ color: '#1C434F', textDecoration: 'underline', width: 'fit-content' }}
        variant={'body2'}
        onMouseEnter={(event: any) => {
          setAnchorEl(event.currentTarget);
        }}
        onMouseLeave={() => {
          setAnchorEl(null);
        }}
      >
        + {props.doctor.addresses.length - 1} more
      </Typography>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement={'bottom-start'}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={{ px: 2, py: 1 }}>
              {props.doctor.addresses.slice(1).map((a, i, arr) => (
                <div key={i}>
                  <Divider
                    sx={{
                      fontSize: 9,
                      color: colors.text.secondary,
                      pb: '4px',
                      pt: i > 0 ? '8px' : undefined,
                    }}
                    textAlign={'left'}
                  >
                    {a.specialty}
                  </Divider>
                  <Address address={a} />
                </div>
              ))}
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
}

const Address = ({
                   address,
                   sx,
                 }: {
  address?: ProviderAddressOutput;
  sx?: SxProps;
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: { xs: 'flex-start', sm: 'flex-end' },
      mt: { xs: 0, sm: 0 },
      ...sx,
    }}
    data-test={'address'}
  >
    <Typography variant={'body2'}>{address?.addressLine1}</Typography>
    <Typography variant={'body2'}>{address?.addressLine2}</Typography>
  </Box>
);
